export enum WidgetConfigFadeFeatureEnum {
	NO_TRUNCATE = '',
	UNFOLDABLE = 'Unfoldable',
	NONUNFOLDABLE = 'NonUnfoldable',
}

export const  WidgetConfigFadeFeatureIndex: {[id: string]: WidgetConfigFadeFeatureEnum} = {
	'': WidgetConfigFadeFeatureEnum.NO_TRUNCATE,
	'Unfoldable': WidgetConfigFadeFeatureEnum.UNFOLDABLE,
	'NonUnfoldable': WidgetConfigFadeFeatureEnum.NONUNFOLDABLE,
};
export default WidgetConfigFadeFeatureEnum;
